'use strict';

var fontMetaData = require('./fontMetaData');
var fontUtils = require('./fontUtils');

module.exports = fontUtils(fontMetaData);
//# sourceMappingURL=fonts.js.map